/**
 * 専用一覧はカラコンのみを扱い、他カテゴリはCMS管理ページが担うため、
 * 一覧では遷移先の固定リンクを持つ。
 */
export interface OtherProductsLink {
  /** カテゴリの表示名。実際の表示文言「〜の一覧」「〜はこちら」等への組み換えは表示側で行う。 */
  readonly name: string
  readonly href: string
}

export const OTHER_PRODUCTS_LINKS: ReadonlyArray<OtherProductsLink> = [
  { name: 'ケア関連用品', href: '/hlothegoods' },
  { name: 'コスメ', href: '/hlcosmeall' },
]
